/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');

window.Vue = require('vue');

Vue.prototype._ = _

import Vue from 'vue'
import VueMoment from 'vue-moment'
import momentTz from 'moment-timezone'
import router from './js/router'
import store from './js/store'
import globalMixins from './js/mixins'
import globalComponents from '@components/globals'
import filters from './js/filters'
import globalHelpers from './js/helpers'
import validation from './js/validation'

import App from './App.vue'

Vue.config.productionTip = false;

Vue.use(globalHelpers);

Vue.use(VueMoment, { momentTz} );

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
